module.exports = __webpack_public_path__ + "static/media/rednote.014da02d.svg";